"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _semanticUiReact = require("semantic-ui-react");

var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));

require("react-loader-spinner/dist/loader/css/react-spinner-loader.css");

var _Colors = require("../00_environment/Colors");

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _SquaredText = _interopRequireDefault(require("../01_atoms/SquaredText"));

var _KeyValueElement = _interopRequireDefault(require("../01_atoms/KeyValueElement"));

var _seat = _interopRequireDefault(require("../../assets/seat.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SeatsValidationMark = function SeatsValidationMark(_ref) {
  var valid = _ref.valid;

  if (!_checkTypes["default"]["boolean"](valid)) {
    return /*#__PURE__*/_react["default"].createElement(_reactLoaderSpinner["default"], {
      type: "Puff",
      color: _Colors.discreetTextColor,
      height: 16,
      width: 16,
      style: {
        marginLeft: 7,
        display: 'inline',
        lineHeight: '1rem'
      }
    });
  }

  if (valid) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      style: {
        color: _Colors.okColor,
        marginLeft: 7,
        width: 10,
        marginBottom: 2
      },
      name: "check"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      color: _Colors.primaryColor,
      marginLeft: 7,
      display: 'inline-block',
      // lineHeight: 16,
      width: 16,
      height: 16
    },
    name: "close"
  });
};

var TripSeatDetailsTwoWays = function TripSeatDetailsTwoWays(_ref2) {
  var sdk = _ref2.sdk,
      _ref2$hasReturn = _ref2.hasReturn,
      hasReturn = _ref2$hasReturn === void 0 ? false : _ref2$hasReturn,
      _ref2$outboundSeats = _ref2.outboundSeats,
      outboundSeats = _ref2$outboundSeats === void 0 ? [] : _ref2$outboundSeats,
      _ref2$returnSeats = _ref2.returnSeats,
      returnSeats = _ref2$returnSeats === void 0 ? [] : _ref2$returnSeats,
      _ref2$onEditOutbound = _ref2.onEditOutbound,
      onEditOutbound = _ref2$onEditOutbound === void 0 ? function () {} : _ref2$onEditOutbound,
      _ref2$onEditReturn = _ref2.onEditReturn,
      onEditReturn = _ref2$onEditReturn === void 0 ? function () {} : _ref2$onEditReturn,
      t = _ref2.translator,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? {} : _ref2$style,
      id = _ref2.id;
  var outboundWithErrors = sdk.seats.selectedSeatsWithErrors(false);
  var returnWithErrors = sdk.seats.selectedSeatsWithErrors(true);
  console.log('outboundWithErrors = ', outboundWithErrors);
  console.log('returnWithErrors = ', returnWithErrors);
  var outboundSeatsValid = outboundWithErrors ? _checkTypes["default"].emptyArray(outboundWithErrors) : null;
  var returnSeatsValid = returnWithErrors ? _checkTypes["default"].emptyArray(returnWithErrors) : null;
  var invalidSquareStyle = {
    borderColor: _Colors.primaryColor,
    color: _Colors.primaryColor
  };
  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    id: id,
    style: style,
    title: t('Selected seats')
  }, /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    header: (outboundSeatsValid === false || returnSeatsValid === false) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
      negative: true
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Header, null, t('Oh no!'), /*#__PURE__*/_react["default"].createElement("br", null), t('These seats are no more available.')), /*#__PURE__*/_react["default"].createElement("p", null, t('Please select other seats to continue.')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      primary: true,
      fluid: true,
      onClick: outboundSeatsValid ? onEditReturn : onEditOutbound
    }, t('Select other seats'))),
    title: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: 'left',
        display: 'inline-block',
        width: 30
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
      src: _seat["default"],
      style: {
        display: 'inline-block',
        height: '22px'
      }
    })), ' ', t('Outbound'), ' ', /*#__PURE__*/_react["default"].createElement(SeatsValidationMark, {
      valid: outboundSeatsValid
    })),
    value: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, outboundSeats.map(function (s) {
      return /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
        key: "placement_out:".concat(s),
        style: _objectSpread({
          width: 24,
          height: 24
        }, _checkTypes["default"].array(outboundWithErrors) && outboundWithErrors.includes(s) ? invalidSquareStyle : {})
      }, s);
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      style: {
        cursor: 'pointer',
        color: _Colors.discreetTextColor,
        marginLeft: 12
      },
      name: "pencil",
      onClick: onEditOutbound
    }))
  }), hasReturn && /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: 'left',
        display: 'inline-block',
        width: 30
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
      src: _seat["default"],
      style: {
        display: 'inline-block',
        height: '22px'
      }
    })), ' ', t('Return')),
    value: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SeatsValidationMark, {
      valid: returnSeatsValid
    }), returnSeats.map(function (s) {
      return /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
        key: "placement_return:".concat(s),
        style: _objectSpread({
          width: 24,
          height: 24
        }, _checkTypes["default"].array(returnWithErrors) && returnWithErrors.includes(s) ? invalidSquareStyle : {})
      }, s);
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      style: {
        cursor: 'pointer',
        color: _Colors.discreetTextColor,
        marginLeft: 12
      },
      name: "pencil",
      onClick: onEditReturn
    }))
  }));
};

var _default = TripSeatDetailsTwoWays;
exports["default"] = _default;